import styled from 'styled-components';

type HeadingProps = {
	title: string;
	showBottomBorder: boolean;
};

export const Heading: React.FC<HeadingProps> = ({
	title,
	showBottomBorder
}) => (
	<Container $showBottomBorder={showBottomBorder}>
		<Title>{title}</Title>
	</Container>
);

const Title = styled.div`
	font-weight: 700;
	font-size: 24px;
`;

const Container = styled.div<{ $showBottomBorder: boolean }>`
	height: 60px;
	background-color: #f5f2f2;
	padding: 0 16px;
	display: flex;
	align-items: center;
	border-bottom: ${props =>
		props.$showBottomBorder ? '1px #000000 solid' : 'none'};
`;
